var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="CDB-Overlay">\n  <button class="CDB-Zoom-action CDB-Zoom-action--out js-zoomOut"></button>\n  <div class="CDB-Zoom-info js-zoomInfo">-</div>\n  <button class="CDB-Zoom-action CDB-Zoom-action--in js-zoomIn"></button>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/geo/ui/zoom/zoom-template.tpl
// module id = 2066
// module chunks = 6